import { Component, Inject, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { PaymentApi } from '@api/payment.api';
import { FormValidationService } from '@services/form-validation.service';
import { PaymentService } from '@services/payment.service';
import { emptyValueValidator } from '@validators/empty-value.validator';
import { DialogData } from '@models/dialog';
import { BatchPaymentFormValue, Payment } from '@models/payment';

@Component({
  selector: 'app-transfer-dialog',
  templateUrl: './transfer-dialog.component.html'
})
export class TransferDialogComponent implements OnDestroy {
  public transferForm: UntypedFormGroup;

  public get amountControl(): UntypedFormControl {
    return <UntypedFormControl>this.transferForm.get('amount');
  }

  public get noteControl(): UntypedFormControl {
    return <UntypedFormControl>this.transferForm.get('notes');
  }

  public payment: Payment;

  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    public dialogRef: MatDialogRef<TransferDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    private api: PaymentApi,
    private validationService: FormValidationService,
    private service: PaymentService
  ) {
    this.payment = this.data.payment;
    this.transferForm = this.createForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onTransferBtnClick(): void {
    const formValue: BatchPaymentFormValue = this.service.prepareBatchTransferFormValue(
      this.transferForm.value,
      this.payment
    );

    this.api.createBatchTransfer(formValue)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (): void => this.dialogRef.close(true),
        (error: string | Error): void => { }
      );
  }

  public getErrorMsg(control: UntypedFormControl, controlName: string): string {
    return this.validationService.getControlErrorMessage(control, controlName);
  }

  private createForm(): UntypedFormGroup {
    const requiredValidator: ValidatorFn = Validators.required,
          {available_balance} = this.payment;

    return this.formBuilder.group({
      order: [null, requiredValidator],
      amount: [available_balance, [
        requiredValidator,
        Validators.min(0.01),
        Validators.max(available_balance)]
      ],
      notes: [null, [requiredValidator, emptyValueValidator]]
    });
  }
}
